import styled from '@emotion/styled'
import CapitariaLogoWhite from '../../ui/images/capitaria-logo-white'
import IconSlogan from '../images/icon-slogan'

const Container = styled.div`
  background-color: #242323;
  display: flex;
  height: 100px;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
`

const LogoSlogan = () => (

  <Container>
    <CapitariaLogoWhite />
    <IconSlogan />
  </Container>

)

export default LogoSlogan
